import { ArrowRight, Check } from "lucide-react";
import { Aparece } from "./Aparece";
import { Boton } from "./Boton";
import { HeroComposicion } from "./mockups/HeroComposicion";

const SENALES = ["Vouchers y liquidaciones con tu sello", "Indicadores económicos al día", "Acompañamiento en la puesta en marcha"];

// Hero CLARO: el login ya es el panel indigo, y la app vive sobre #F8FAFC. La landing se presenta
// como la app que vas a usar, no como otra pantalla de login.
//
// Mide EXACTAMENTE una pantalla menos la navbar (`100svh − 4rem`), como el de xpendit.com: así la
// capa siguiente arranca justo en el borde inferior y entra con el primer scroll, con o sin zoom del
// navegador. Si midiera lo que mide su contenido, en pantallas altas la capa asomaría al cargar y en
// pantallas bajas (o con zoom) el hero sobraría por abajo y habría que scrollearlo antes de que se
// fije. En pantallas BAJAS se compacta (márgenes y título) para caber; si aun así no cabe —celular,
// con el mockup debajo del texto— `HeroFijo` lo deja recorrer entero antes de fijarlo.
export const Hero = () => (
  <section id="inicio" className="relative flex min-h-[calc(100svh-4rem)] items-center overflow-hidden bg-slate-50" data-testid="landing-hero">
    <div className="mx-auto grid w-full max-w-6xl items-center gap-12 px-4 pb-16 pt-10 sm:px-6 sm:pt-16 lg:grid-cols-[1.1fr_1fr] lg:gap-10 lg:py-10 [@media(min-width:1024px)_and_(max-height:760px)]:py-4">
      <div>
        <Aparece>
          <p className="inline-flex items-center gap-2 rounded-full bg-white px-3 py-1 text-xs font-semibold text-indigo-700 ring-1 ring-inset ring-indigo-100">
            <span className="h-1.5 w-1.5 rounded-full bg-indigo-500" />
            Para corredoras y administradores de propiedades
          </p>
        </Aparece>
        <Aparece delay={0.05}>
          <h1 className="mt-5 font-display text-4xl font-extrabold leading-[1.08] tracking-tight text-slate-900 sm:text-5xl lg:text-[2.75rem] xl:text-5xl [@media(min-width:1024px)_and_(max-height:760px)]:text-4xl">
            Administra tus arriendos y ventas{" "}
            <span className="relative inline-block whitespace-nowrap">
              sin planillas.
              {/* La firma dorada: una línea bajo dos palabras, nunca texto dorado sobre claro. */}
              <svg
                className="absolute -bottom-1.5 left-0 h-2.5 w-full"
                viewBox="0 0 200 10"
                preserveAspectRatio="none"
                aria-hidden="true"
              >
                <defs>
                  <linearGradient id="lp-oro" x1="0" x2="1" y1="0" y2="0">
                    <stop offset="0" stopColor="#C7A050" />
                    <stop offset="0.5" stopColor="#F7EB97" />
                    <stop offset="1" stopColor="#D4B361" />
                  </linearGradient>
                </defs>
                <path d="M2 7 C 60 2, 140 2, 198 6" fill="none" stroke="url(#lp-oro)" strokeWidth="4" strokeLinecap="round" />
              </svg>
            </span>{" "}
            <span className="block text-slate-400">Cobros, pagos, liquidaciones y reajustes IPC automáticos.</span>
          </h1>
        </Aparece>
        <Aparece delay={0.1}>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-slate-600 sm:text-lg">
            Registra cada pago, cierra el mes y rinde a cada propietario con su liquidación lista. SEBBIA hace los
            cálculos; tú te ocupas de tus clientes.
          </p>
        </Aparece>
        <Aparece delay={0.15} className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Boton href="#demo" tamano="lg" data-testid="hero-demo">
            Agenda una demo <ArrowRight className="h-4 w-4" />
          </Boton>
          <Boton href="#como-funciona" variante="secundario" tamano="lg">
            Ver cómo funciona
          </Boton>
        </Aparece>
        <Aparece delay={0.2}>
          <ul className="mt-8 flex flex-wrap gap-x-5 gap-y-2">
            {SENALES.map((s) => (
              <li key={s} className="flex items-center gap-1.5 text-sm text-slate-500">
                <Check className="h-4 w-4 text-emerald-500" /> {s}
              </li>
            ))}
          </ul>
        </Aparece>
      </div>

      <div className="relative mx-auto w-full max-w-xl lg:max-w-none">
        <HeroComposicion />
      </div>
    </div>
  </section>
);
